/* eslint-disable arrow-body-style */
import React from 'react';
import Image from 'next/legacy/image';
import cn from 'classnames';
import Markdown from 'markdown-to-jsx';
import s from './Hero.module.scss';

type Content = {
  backgroundImage?: any;
  title: string;
  subtitle: string;
};

type HeroProps = {
  content: Content;
  widget?: any;
};

export const Hero = ({ content, widget }: HeroProps) => (
  <div className={s.root}>
    <div className={s.info}>
      {content?.backgroundImage?.data?.attributes?.url ? (
        <div className={s.image_box}>
          {content?.backgroundImage?.data?.attributes?.url && (
            <Image
              src={content?.backgroundImage?.data?.attributes?.url}
              layout="fill"
              objectFit="cover"
              objectPosition="center"
              alt={
                content?.backgroundImage?.data?.attributes?.alternativeText ??
                'Park+ Team'
              }
              priority
            />
          )}
        </div>
      ) : (
        content?.backgroundImage?.url && (
          <div className={s.image_box}>
            {content?.backgroundImage?.url && (
              <Image
                src={content?.backgroundImage?.url}
                layout="fill"
                objectFit="cover"
                objectPosition="center"
                alt={content?.backgroundImage?.alternativeText ?? 'Park+ Team'}
                priority
              />
            )}
          </div>
        )
      )}

      {content?.backgroundImage?.data && <div className={cn(s.overlay)} />}
      <div className={cn('cmn_container', s.box)}>
        {content?.title && (
          <Markdown className={s.title}>{content?.title || ''}</Markdown>
        )}
        {content?.subtitle && (
          <Markdown className={s.subtitle}>{content?.subtitle || ''}</Markdown>
        )}
      </div>
    </div>
    {widget && (
      <div className={s.widget_container}>
        <div className={cn('cmn_container', s.box)}>
          <div className={s.widget}>{widget}</div>
        </div>
      </div>
    )}
  </div>
);